/* globals __DEV__:true */

import {isFunction, isPromise} from '@malt/common';

/**
 * Destroy previously attached module on given DOM node.
 *
 * Note that this function does not try to gown in the DOM tree, it "just" destroy
 * hopmodules found on this DOM node.
 *
 * @param {HTMLElement} el DOM Node.
 * @return {void}
 */
export function destroyModulesFromEl(el) {
    if (el.hop) {
        el.hop.forEach(destroyModule);
        el.hop = null;
    }
}

function destroyModule(mod) {
    if (mod.destroy) {
        runDestroy(mod);
    } else if (__DEV__) {
        console.warn(`Module ${mod.id} has been destroyed but does not have any destroy function, it may cause some issues or memory leaks`);
    }
}

function runDestroy(mod) {
    if (isPromise(mod.destroy)) {
        mod.destroy.then((destroyFn) => destroyFn());
    } else if (isFunction(mod.destroy)) {
        mod.destroy();
    } else {
        throw new Error(`Cannot destroy module '${mod.id}', return value is not a function, nor a promise`);
    }
}
